import { useNavigate } from 'react-router-dom';

import LogoImage from '../../../assets/images/Logo_blue_2x.svg';

export default function HeaderWithoutMenu() {
  const navigate = useNavigate();

  const goToPage = (path) => {
    navigate(path);
  };

  return (
    <div className="w-full px-6 sm:px-12 xl:px-20 py-6 bg-white border border-[#FDFDFD] flex items-center justify-between">
      <button onClick={() => goToPage('/')}>
        <img
          src={LogoImage}
          alt="Logo"
          className="w-30 h-10 sm:w-39 sm:h-17 object-cover"
        />
      </button>

      <div className="flex space-x-2 font-medium items-center justify-center">
        <button
          className="px-4 sm:px-8 py-1.5 sm:py-2.5 text-sm sm:text-base text-[#092F7B] bg-[#E6EBF7] border border-[#092F7B] rounded-[10px] cursor-pointer leading-[1.45] tracking-[0%]"
          onClick={() => goToPage('/login')}
        >
          Iniciar sesión
        </button>
        <button
          className="px-4 sm:px-8 py-1.5 sm:py-2.5 text-sm sm:text-base text-white bg-[#092F7B] rounded-[10px] cursor-pointer leading-[1.45] tracking-[0%]"
          onClick={() => goToPage('/register')}
        >
          Registrarse
        </button>
      </div>
    </div>
  );
}
